import React from "react";

// eslint-disable-next-line react/prop-types
export const Icon = ({ icon, extraClass = "", onClick = () => {} }) => (
  <svg className={`icon icon-${icon} ${extraClass}`} onClick={onClick}>
    <use xlinkHref={`/icons/icons.svg#${icon}`} />
  </svg>
);
